<template>
  <main v-if="list.length">
    <div class="break-rules-ranking-list driver-break-rules-list">
      <div class="brrl-title driver-break-title">
        <span
          class="brrl-title-text"
          :class="{ 'no-border-brrl-title-text': !isShowBorder }"
          >车辆违章榜TOP10</span
        >
        <slot name="radionBtn"></slot>
        <el-export-btn
          v-if="canExport"
          keyUrl="/proxy/violation/analyze/vehicle/export"
          statusUrl="/proxy/api/getFileUrl"
          :params="exportParams"
        />
      </div>
      <el-table
        :data="list"
        :default-sort="{ prop: 'totalViolationCount', order: 'descending' }"
        @sort-change="sortChange"
        style="width: 100%"
      >
        <el-table-column
          prop="licensePlateNumber"
          label="车牌号"
          min-width="125"
          fixed="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{
              scope.row.licensePlateNumber ? scope.row.licensePlateNumber : '--'
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="driverName"
          :show-overflow-tooltip="true"
          label="司机"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.driverName ? scope.row.driverName : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalViolationCount"
          min-width="130px"
          label="违章次数"
          sortable="custom"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{
              scope.row.totalViolationCount
                ? scope.row.totalViolationCount
                : '--'
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="罚金(元)"
          min-width="130px"
          prop="totalPunishCount"
          sortable="custom"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.totalPunishCount
                ? $utils.toYuan(scope.row.totalPunishCount)
                : '--'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="扣分"
          :show-overflow-tooltip="true"
          sortable="custom"
          prop="totalDeductMarks"
          min-width="120px"
        >
          <template slot-scope="scope">
            {{ scope.row.totalDeductMarks ? scope.row.totalDeductMarks : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="140px"
          label="联系方式"
          :show-overflow-tooltip="true"
          prop="driverMobile"
        >
          <template slot-scope="scope">
            {{ scope.row.driverMobile ? scope.row.driverMobile : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          width="220px"
          label="合同号"
          prop="contractCode"
          class-name="info-column"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.contractCode ? scope.row.contractCode : '--' }}
            <el-popover
              placement="bottom-end"
              popper-class="self_popver_bg"
              :v-model="true"
              trigger="hover"
            >
              <div class="self-contract-wrapper">
                <el-contract-card
                  v-for="(item, index) in getContract(scope.row.contract)"
                  :key="index"
                  :detail="item"
                  :flag="true"
                  :style="{
                    'margin-bottom':
                      getContract(scope.row.contracts).length > 1
                        ? '10px'
                        : '0',
                  }"
                />
              </div>
              <span slot="reference">
                <img
                  src="../../assets/images/auth/alert-icon.svg"
                  alt=""
                  v-if="scope.row.contractCode"
                />
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="120px">
          <template slot-scope="scope">
            <span
              style="color:#2f86f6;cursor:pointer;"
              class="fresh-btn"
              @click="showBreakRulesFromPlateNo(scope.row)"
              >违章详情</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-contract-view></el-contract-view>
  </main>
</template>
<script>
import moment from 'moment'
import * as constant from '../../constant/common-type'
import contractCard from '../console-common/contract-board.vue'
import contractView from '../contract/contract-view.vue'
import exportBtn from '../../components/console-common/export-btn.vue'
export default {
  components: {
    'el-export-btn': exportBtn,
    'el-contract-view': contractView,
    'el-contract-card': contractCard,
  },
  created() {
    this.analyzeDriverList()
  },
  watch: {
    time: {
      handler(val) {
        this.analyzeDriverList()
        this.exportParams = {
          ...this.exportParams,
          startTime: val.startTime,
          endTime: val.endTime,
        }
      },
      deep: true,
    },
  },
  props: {
    time: {
      type: Object,
      require: false,
    },
    canExport: {
      type: Boolean,
      default() {
        return true
      },
      require: false,
    },
    isShowBorder: {
      type: Boolean,
      default() {
        return true
      },
      require: false,
    },
    isShowNoLimit: {
      type: Boolean,
      default() {
        return true
      },
      require: false,
    },
  },
  data() {
    return {
      list: [],
      time1: 'VIOLATION_TIMES',
      exportParams: {},
    }
  },
  computed: {},
  methods: {
    /**
     * 跳转到历史违章记录页
     */
    vehicleHistoryViolation(params) {
      params = params ? params : {}
      this.$router.push({
        path: '/console/violation/history-violation-query',
        query: {
          ...params,
        },
      })
    },
    showBreakRulesFromPlateNo(row) {
      this.vehicleHistoryViolation({
        licensePlateNumber: row.licensePlateNumber,
      })
    },
    /**
     * 车辆排行榜
     */
    analyzeDriverList(
      params,
      order = 'descending',
      prop = 'totalViolationCount'
    ) {
      let data = {}
      if (params) {
        data = {
          startTime: this.time.startTime,
          endTime: this.time.endTime,
          ...params,
        }
      } else {
        data = {
          startTime: this.time.startTime,
          endTime: this.time.endTime,
          dimension: 'VIOLATION_TIMES',
        }
      }
      this.$request({
        url: '/proxy/violation/analyze/vehicle',
        method: 'post',
        data: data,
        isShowNoLimit: this.isShowNoLimit,
      }).then((res) => {
        if (!res) return
        if (res && !res.errorCode && res.data) {
          const soreArr = (proto) => (item1, item2) => {
            if (order === 'descending') return item2[proto] - item1[proto]
            else return item1[proto] - item2[proto]
          }
          this.list = res.data.sort(soreArr(prop))
        }
      })
    },
    // 排序
    sortChange(data) {
      const { column, prop, order } = data
      let params = {}
      switch (prop) {
        case 'totalViolationCount':
          params = {
            dimension: 'VIOLATION_TIMES',
          }
          this.exportParams = {
            startTime: this.time.startTime,
            endTime: this.time.endTime,
            dimension: 'VIOLATION_TIMES',
          }
          this.analyzeDriverList(params, order, prop)
          break
        case 'totalPunishCount':
          params = {
            dimension: 'PUNISH_COUNT',
          }
          this.exportParams = {
            startTime: this.time.startTime,
            endTime: this.time.endTime,
            dimension: 'PUNISH_COUNT',
          }
          this.analyzeDriverList(params, order, prop)
          break
        case 'totalDeductMarks':
          params = {
            dimension: 'DEDUCT_MARKS',
          }
          this.exportParams = {
            startTime: this.time.startTime,
            endTime: this.time.endTime,
            dimension: 'DEDUCT_MARKS',
          }
          this.analyzeDriverList(params, order, prop)
          break
      }
    },
    // 合同信息
    getContract(list) {
      let array = []
      if (list) {
        let obj = {
          orderNo: '',
          status: '',
          list: [],
        }
        obj.orderNo = list.contractCode
        obj.status = list.contractProcess
        obj.list = [
          {
            key: '司机姓名',
            val: list.driverName,
          },
          {
            key: '车牌号',
            val: list.plateNumber,
            push: 4,
          },
          {
            key: '注册手机号',
            val: list.driverMobile,
            span: 24,
          },
          {
            key: '业务模式',
            val: constant.leaseMode[list.leaseMode],
          },
          {
            key: '租金',
            val: `￥${this.$utils.toYuan(list.monthlyPayment)}`,
            push: 4,
          },
          {
            key: '合同有效期',
            val: `${moment(list.startTime).format('YYYY-MM-DD')} 至 ${moment(
              list.endTime
            ).format('YYYY-MM-DD')}`,
            span: 24,
          },
        ]
        array.push(obj)
      }
      return array
    },
  },
}
</script>
<style lang="stylus">
@import '../../assets/css/common-color.styl'
  .break-rules-ranking-list
    margin-top 40px
    .brrl-title
      font-family PingFangSC-Medium
      font-size 16px
      color #41485d
      display flex
      align-items center
      justify-content space-between
      .brrl-title-text
        display inline-block
        height 16px
        line-height 16px
        border-left 2px solid #2f86f6
        padding-left 8px
        font-family PingFangSC-medium
      .no-border-brrl-title-text
        border none
        padding-left 0
        font-size 18px
        color #111a34
      // .el-radio-group
      //   border 2px solid #F0F0F0
      //   border-radius 4px
      // .el-radio-button, .el-radio-button__inner
      //   background #f0f0f0
      // .el-radio-button__orig-radio:checked+.el-radio-button__inner
      //   background #FFFFFF
      //   border none
      //   border-radius 4px
      //   font-family PingFangSC-Regular
      //   font-size 12px
      //   color #41485D
      // .el-radio-button__orig-radio+.el-radio-button__inner
      //   box-shadow none
      //   background #F0F0F0
      //   border none
      //   color #666f83
      //   &:hover
      //     color #41485D
      // .el-input-group__append, .el-input-group__prepend
      //   background #F0F0F0
    .ranking-list-info
      .rli-detail
        margin-top 20px
        display flex
        align-items center
        padding-left 9px
        .rli-detail-text
          font-family PingFangSC-Regular
          font-size 14px
          color #41485D
          text-align right
          line-height 20px
          margin-right 14px
          width 55%
          display inline-block
          .rli-detail-text-icon
            background url(../../assets/images/violation-manage/bg-rl.svg) no-repeat center center
            background-size 100% 100%
            display inline-block
            width 18px
            height 18px
            text-align center
            line-height 18px
            color #fff
            font-size 12px
            font-weight 300
        .rli-detail-process
          display inline-block
          background rgba(47,134,246,0.5)
          margin-right 10px
          height 18px
        .orange
          background rgba(255,125,65,0.5)
        .green
          background rgba(40,170,145,0.5)
        .rli-detail-count
          font-family PingFangSC-Regular
          font-size 12px
          color #41485D
          line-height 12px
          display flex
  .driver-break-rules-list
    .driver-break-title
      margin-bottom 18px
      #export-btn-wrapper
        .export-wrapper
          margin-bottom 0px
    .el-table th
      padding 13px 0
    .el-table td
      padding 20px 0
    .el-table th .cell
      color #666f83
.self_popver_bg
  background  #ebeef5
  padding 0
.self-contract-wrapper
  max-height 370px
  overflow-y auto
  overflow-x hidden
  .contract-board
    background white
    width 340px
    border none
    margin-bottom 8px
.self-contract-wrapper::-webkit-scrollbar
  width 8px
  height 8px
.self-contract-wrapper::-webkit-scrollbar-thumb
  border-radius 2px
  -webkit-box-shadow inset 0 0 5px rgba(0,0,0,0.2)
  background #ebedf1
.self-contract-wrapper::-webkit-scrollbar-track
  display none
</style>
